import type { StorePermitPayload } from '@extJurAutofill/externalPackagesContract/StorePermitPayload';
import { MessageType } from '@extJurAutofill/shared/MessageType';

export interface StorePermitMessage {
  type: MessageType.STORE_PERMIT;
  payload: StorePermitPayload;
}

const MESSAGE_TYPE = MessageType.STORE_PERMIT;

export const dispatchStorePermitMessage = (payload: StorePermitPayload) => {
  window.postMessage({ payload, type: MESSAGE_TYPE }, window.location.origin);
};

export const listenForStorePermitMessage = (
  handler: (payload: StorePermitMessage) => void,
): (() => void) => {
  const listener = (event: MessageEvent) => {
    if (event.source !== window || event.origin !== location.origin) return;
    if (event.data?.type !== MESSAGE_TYPE) return;
    handler(event.data as StorePermitMessage);
  };

  window.addEventListener('message', listener);
  return () => window.removeEventListener('message', listener);
};
